import {
  renderMainLeftCell,
  renderMainRightCell,
  renderColumnGaps
} from '../helpers';
import { percentSingleDecimal } from '../download-data-styles';

export const renderAllocationRow = (label, value) => {
  let rowString = `<tr>`;
  rowString += renderMainLeftCell(label);
  rowString += renderMainRightCell(`${value}%`, percentSingleDecimal);
  rowString += `</tr>`;
  return rowString;
};

export const renderAllocationFundRow = (label, value) => {
  let rowString = `<tr>`;
  rowString += renderColumnGaps(1);
  rowString += renderMainLeftCell(label);
  rowString += renderMainRightCell(`${value}%`, percentSingleDecimal);
  rowString += `</tr>`;
  return rowString;
};
